import apollo from '@/apollo.js'
import gql from 'graphql-tag'

const systemEmailFields = `
  id
  key
  title
  description
  subject
  template
  variables
  sampleInput
`

export const systemEmailTemplates = async () => {
  const response = await apollo.query({
    query: gql(`
      query systemEmailTemplates {
        systemEmailTemplates { ${systemEmailFields} }
      }
    `),
    fetchPolicy: "network-only"
  })
  return response.data.systemEmailTemplates
}

export const updateSystemEmailTemplate = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation updateSystemEmailTemplate($id: Int!, $subject: String!, $template: String!) {
        updateSystemEmailTemplate(id: $id, subject: $subject, template: $template) {
          error
          message
          lowLevelErrorMessage
          template { ${systemEmailFields} }
        }
      }
    `),
    variables: { id: data.id, subject: data.subject, template: data.template || "" }
  })
  return response.data.updateSystemEmailTemplate
}

export const resetSystemEmailTemplate = async (id) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation resetSystemEmailTemplate($id: Int!) {
        resetSystemEmailTemplate(id: $id) {
          error
          message
          lowLevelErrorMessage
          template { ${systemEmailFields} }
        }
      }
    `),
    variables: { id: id }
  })
  return response.data.resetSystemEmailTemplate
}
